import React, { useEffect, useState, useContext } from "react";
import close_btn from "../../../assets/images/close_btn.png";
import axios from "axios";
import { toast } from "react-toastify";
import { tableDataContext } from "../../context/productData";
import { Table } from "antd";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import { useParams } from "react-router-dom";

function Recommended(props) {
  const {
    ven_name,
    setVen_name,
    dbdatapdf,
    setResponsedatapdf,
    responseDatapdf,
    setSelectedFileName,
    newLoader,
    setNewLoader,
    setShow,
    setLoaderModal,
    setOpenModal,
  } = props;
  const [deleteFile1, setDeleteFile] = useState(false);
  const handleCloseModal1 = () => setDeleteFile(false);
  const handleShowModal1 = () => setDeleteFile(true);
  const { pdfData, setPdfData, allResponse, setAllResponse } =
    useContext(tableDataContext);
  const { id } = useParams();
  const venName = localStorage.getItem("venName");
  const fileName = localStorage.getItem("pdf_name");

  useEffect(() => {
    const processResponseData = (data) => {
      try {
        if (data === "start") {
          setNewLoader(true);
        } else if (data === "done") {
          setNewLoader(false);
        } else {
          const newProducts = data.flatMap((dataItem) => {
            const outputParsed = JSON.parse(dataItem?.output.output);
            return outputParsed.filter(
              (item) => item["Product Name"] && item["Product Name"] !== "null"
            );
          });

          setAllResponse((prev) =>
            deduplicateProducts([...prev, ...newProducts])
          );
        }
      } catch (error) {
        console.error("Error processing response data:", error);
      }
    };

    if (responseDatapdf) {
      processResponseData(responseDatapdf);
    }

    if (dbdatapdf) {
      try {
        const dbProducts = dbdatapdf.flatMap((item) => {
          const outputParsed = JSON.parse(item);
          return outputParsed.filter(
            (product) =>
              product["Product Name"] && product["Product Name"] !== "null"
          );
        });

        setAllResponse((prev) => deduplicateProducts([...prev, ...dbProducts]));
      } catch (error) {
        console.error("Error processing db data:", error);
      }
    }
  }, [responseDatapdf, dbdatapdf]);

  const deduplicateProducts = (products) => {
    const uniqueProducts = [];
    const productNames = new Set();

    products.forEach((product) => {
      if (!productNames.has(product["Product Name"])) {
        uniqueProducts.push(product);
        productNames.add(product["Product Name"]);
      }
    });

    return uniqueProducts;
  };

  const handleBackButton = () => {
    setPdfData("");
    setResponsedatapdf("");
    console.log(pdfData);
    console.log(responseDatapdf);
    setVen_name("");
    setSelectedFileName("");
    setShow(false);
  };

  const handleRemoveButton = () => {
    axios
      .post(
        "https://aipricingtool-python.onrender.com/delete_output_by_pdf_name",
        {
          pdf_name: fileName,
          vendor_name: ven_name,
          user_identifier: id,
        }
      )
      .then((response) => {
        setLoaderModal(false);
        setSelectedFileName("");
        setResponsedatapdf("");
        setShow(false);
        setAllResponse("");
        setPdfData("");
        setOpenModal(false);
        setVen_name("");
        toast.success("Pdf Removed Successfully");
      })
      .catch((err) => {
        toast.error("Error Removing Pdf");
        // console.log(err);
      });
  };

  console.log(allResponse);
  const columns = [
    {
      title: "Product Name",
      dataIndex: "name",
      key: "name",
      render: (text, record) => (
        <>
          {record["Product Name"] === "null" ? (
            <label className="product-name medium font-inter fw-medium  ">
              --
            </label>
          ) : (
            <label className="product-name medium font-inter fw-medium  ">
              {record["Product Name"]}
            </label>
          )}
        </>
      ),
    },
    {
      title: "Discount",
      dataIndex: "Discount",
      key: "Discount",
      render: (text, record) => (
        <>
          {record.Discount ? (
            <label className="product-name medium font-inter fw-medium">
              {record.Discount}
            </label>
          ) : (
            <label className="product-name medium font-inter fw-medium">
              --
            </label>
          )}
        </>
      ),
    },
    {
      title: "Quantity",
      dataIndex: "name",
      key: "Quantity",
      render: (text, record) => (
        <>
          {" "}
          {record["Quantity"] ? (
            <label className="product-name medium font-inter fw-medium">
              {record["Quantity"]}
            </label>
          ) : (
            <label className="product-name medium font-inter fw-medium">
              --
            </label>
          )}
        </>
      ),
    },
    {
      title: "Current Price (лв)",
      dataIndex: "Current",
      key: "Current",
      render: (text, record) => (
        <>
          {record["Current Price"] ? (
            <label className="product-name medium font-inter fw-medium">
              {record["Current Price"]
                .replace(/[^\d,.]/g, "")
                .replace(/,/g, ".")}
            </label>
          ) : (
            <label className="product-name medium font-inter fw-medium">
              --
            </label>
          )}
        </>
      ),
    },
    {
      title: "Regular Price (лв)",
      dataIndex: "Old",
      key: "Old",
      render: (text, record) => (
        <>
          {record["Old Price"] ? (
            <label className="product-name medium font-inter fw-medium">
              {record["Old Price"].replace(/[^\d,.]/g, "").replace(/,/g, ".")}
            </label>
          ) : (
            <label className="product-name medium font-inter fw-medium">
              --
            </label>
          )}
        </>
      ),
    },
    {
      title: "Deadline",
      dataIndex: "date",
      key: "date",
      render: () => {
        let dateRegex =
          /(\d{2}[.-\s](?:\d{2}|януари|февруари|март|април|май|юни|юли|август|септември|октомври|ноември|декември)[.-\s]\d{4}|\d{8})/gi;
        let matches = fileName.match(dateRegex);
        console.log(fileName);
        let desiredDate =
          matches && matches?.length > 0 ? matches[matches?.length - 1] : null;
        console.log("From Recommended Dd", desiredDate);
        return (
          <>
            {fileName ? (
              <label className="product-name medium font-inter fw-medium">
                {desiredDate}
              </label>
            ) : (
              <label className="product-name medium font-inter fw-medium">
                --
              </label>
            )}
          </>
        );
      },
    },
  ];

  return (
    <>
      <div className="flex flex-column justify-center ">
        <div className="">
          <p
            className={` text-xl w-[60%] md:text-3xl mb-2 font-semibold pl-8 ${
              ven_name?.length > 20 ? "truncate primary" : "primary"
            } `}
          >
            Vendor Name: {ven_name ? ven_name : venName}
          </p>
          <p
            className={`overflow-hidden w-[60%] ${
              fileName?.length > 20
                ? "truncate text-xl md:text-3xl mb-2 font-semibold pl-8 primary  "
                : ""
            }`}
          >
            Pdf Name : {fileName ? fileName : "Short Pdf"}
          </p>
        </div>
        <div className="recommended overflow-hidden d-flex flex-column space-between  setting rounded-xl md:rounded-2xl  mb-6">
          <div className="overflow-scroll pt-3 px-4 d-flex flex-column justify-between   h-[500px] rounded-lg scrollbar-thin scrollbar-thumb-gray-300 scrollbar-track-gray-100  table-roundess">
            <Table
              dataSource={allResponse}
              columns={columns}
              className="analyzed-table"
            />
            {newLoader && (
              <div class="w-100 d-flex justify-center">
                <div className="spinner"></div>
              </div>
            )}
          </div>
        </div>
      </div>
      <div className="w-100 flex justify-around ">
        <button
          className={` text-white rounded-lg px-5 ${
            newLoader ? "bg-[#b4644e] cursor-not-allowed" : "bg-[#b85b42]"
          }   `}
          onClick={() => {
            handleBackButton();
          }}
          style={{
            background:
              "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
          }}
        >
          {"<"} Back
        </button>
        <button
          className={`py-2.5 text-white rounded-lg px-4 ${
            newLoader === true
              ? "bg-[#b4644e] cursor-not-allowed"
              : "bg-[#b85b42]"
          }   `}
          disabled={newLoader ? true : false}
          onClick={handleShowModal1}
          style={{
            background:
              "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
          }}
        >
          Delete Result
        </button>
      </div>
      <Modal
        className="removeModal-1"
        onHide={handleCloseModal1}
        centered={true}
        show={deleteFile1}
      >
        <div className="px-4 py-4">
          <div className="close_btn  d-flex justify-end mb-5">
            <img
              src={close_btn}
              alt=""
              onClick={handleCloseModal1}
              className="cursor-pointer"
            />
          </div>
          <div className="header-1 d-flex flex-column jutsify-center align-center gap-y-12">
            <Modal.Title className="text-center w-5/6">
              Are you Sure You Want To Permanently Delete This File and Data
              against it?
            </Modal.Title>
            <div className="d-flex gap-3 jutsify-center align-center m-auto mb-5">
              <Button
                className="btn-2 text-black Campton w-[101px]"
                onClick={() => {
                  handleRemoveButton();
                }}
                style={{
                  border: "1px solid var(--Menu-Buttons-Grad, #D76E3E)",
                  background: "transparent",
                }}
              >
                Yes
              </Button>
              <Button
                className="btn-1 w-[101px]"
                onClick={handleCloseModal1}
                style={{
                  background:
                    "linear-gradient(102deg, #D73E3E 20.86%, #6B2B4B 120.36%)",
                  border: "none",
                }}
              >
                No
              </Button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Recommended;
